export const isInFrame = window.top !== window.self

// Loadings
export const LoadingLinkingShipper = 'Loading_LinkingShipper'
export const LoadingUnLinkingShipper = 'Loading_UnLinkingShipper'

export const LoadingDisconnect = 'Loading_Disconnect'
export const LoadingShippers = 'LoadingShippers'
export const LoadingConnectedInfo = 'LoadingConnectedInfo'
